import React, {Fragment} from 'react'
import {Modal} from 'antd'
import {connect} from "react-redux";

class SystemMsgModalContainer extends React.Component {
    render() {
        console.log('modalIsOpen:' + this.props.modalIsOpen)
        return (
            <Fragment>
                <Modal
                    visible={this.props.modalIsOpen}
                    closable={false}
                    footer={null}
                >
                    <h3>{this.props.modalMsg}</h3>
                </Modal>
            </Fragment>
        )
    }
}

const mapStateTOProps = (state) => {
    return {
        modalIsOpen: state.getIn(['ModalData', 'modalIsOpen', 'system_msg']),
        modalMsg: state.getIn(['ModalData', 'modalMsg']),
    }
};
const mapDispatchTOProps = (dispatch) => ({
    // closeModal: () => (
    //     dispatch(closeModal(dispatch))
    // ),
})
export default connect(mapStateTOProps, mapDispatchTOProps)(SystemMsgModalContainer)


// WEBPACK FOOTER //
// ./src/dashboards_redux/containers/DefaultModalTemplatContainer/SystemMsgModalContainer.jsx